import { render, staticRenderFns } from "./CardApplicationConfigMember.vue?vue&type=template&id=0a490456&scoped=true&"
import script from "./CardApplicationConfigMember.vue?vue&type=script&lang=js&"
export * from "./CardApplicationConfigMember.vue?vue&type=script&lang=js&"
import style0 from "./CardApplicationConfigMember.vue?vue&type=style&index=0&id=0a490456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a490456",
  null
  
)

export default component.exports